import { Image, Platform, View } from 'react-native';
import React from 'react';
import { s, v } from '../../../utils/libs';
import { isTablet } from 'react-native-device-info';
import { useLayoutSize } from '../../../theme/LayoutSizeContext';

export const HeaderTitle = () => {
  const { useSidebarNav } = useLayoutSize();
  return (
    <View>
      <Image
        source={require('../../../assets/BizplusLogo-simple.webp')}
        style={{
          width: s(100),
          height: v(useSidebarNav ? 60 : isTablet() ? 36 : 40),
          marginTop: v(-4),
        }}
        resizeMode="contain"
      />
    </View>
  );
};

export default HeaderTitle;
